<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column
                    label="Nom de la banque du {{ supportType }}"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreBankName"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Ville de la banque du {{ supportType }}"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreBankCity"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Code bancaire du RIB Titres"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreRibBankingCode"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Code guichet du RIB Titres"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreRibBranchCode"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Numéro de compte du RIB"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreRibAccountNumber"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column
                    label="Clé RIB du RIB Titre"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="crowdfundingPeaPmeTitreRibKey"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
